import { Box } from '@n26/nxd'
import type { PopularSectionProps } from './PopularSection'
import { SmallArticleCard } from './SmallArticleCard'
import { useGetBlogUrl } from '@hooks/useGetBlogUrls'
import { ZoomInImage } from '@components/ZoomInImage'

type PopularSectionHeroProps = { article: PopularSectionProps['articles'][0] }

export const PopularSectionHero = ({ article }: PopularSectionHeroProps) => {
  const { title, previewImage, slug } = article || {}
  const blogUrl = useGetBlogUrl('blog', slug)

  return (
    <Box position='relative'>
      <ZoomInImage
        url={blogUrl}
        aspectRatio='pt-[94%]'
        imgSrc={previewImage?.url || ''}
        imgAlt={previewImage?.description || title || ''}
        isBorderRadiusSmall={false}
      />
      <Box position='absolute' bottom='0' margin='32'>
        <Box
          padding='24'
          backgroundColor='neutral'
          borderRadius='4'
          className='w-fit'
        >
          <SmallArticleCard article={article} alignTextCenter />
        </Box>
      </Box>
    </Box>
  )
}
